export function useMarks(marks: number[]) {
    const relativeWidths: number[] = [];
    const first = marks[0];
    const last = marks[marks.length - 1];
    const total = last - first;
    marks.reduce((previousValue, currentValue) => {
        relativeWidths.push(((currentValue - previousValue) * 100) / total);
        return currentValue;
    });
    return relativeWidths;
}
